import Carousel from './components/Carousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import once from 'lodash/once';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from './components/scrollable';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';
import { scrollToElement } from 'common/utils/scroll';
import { trackEvent, trackLink } from '@99designs/common/utils/platform';
import FeaturedContestInspiration from './components/FeaturedContestInspiration';
import SlideCarousel from './components/slide-carousel';
import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';
import { initDesignerQuotesList } from 'marketing/components/DesignerQuotesList';
import StickyBar from './components/StickyBar';
import Waypoint from 'waypoints/lib/noframework.waypoints';
import { init as InitGetStartedInteractive } from 'interactive/get-started-interactive';

// Enable Logo+ Interactive if present
document.addEventListener('DOMContentLoaded', () => {
    const interactiveElement = document.getElementById('get_started_interactive');

    if (!interactiveElement) {
        return;
    }

    const key = interactiveElement.getAttribute('data-get-started-interactive-category-key');

    InitGetStartedInteractive({
        container: interactiveElement.querySelector('[data-get-started-interactive-inner]'),
        categoryKey: key,
        logoDesignBundlePrices: window.logoDesignBundlePrices || [],
    });
});

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    const scrollToLinks = document.querySelectorAll('[data-hero-scrollto-link]');

    for (var i = 0; i < scrollToLinks.length; i++) {
        new ScrollToElement(scrollToLinks[i]).handleClick();
    }

    new FeaturedContestInspiration();
});

document.addEventListener('DOMContentLoaded', () => {
    // Track FAQ usage to Segment
    const accordionTriggers = document.querySelectorAll('#faqs [data-accordion-item-trigger]');

    for (var i = 0; i < accordionTriggers.length; i++) {
        const trigger = accordionTriggers[i];

        trigger.addEventListener('click', e =>
            trackEvent('Clicked FAQ on Product Page', {
                title: trigger.textContent.trim(),
            })
        );
    }

    // Product features
    createProductFeatures();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // horizontally scrollable elements
    initDesignerQuotesList();
    createScrollableElements();
    trackDesignerQuotesListEvents();

    // Example designs
    scrollOnHover('[data-scrollable="examples"]');
    centerAlignScrollableElement('[data-scrollable="examples"]').then(el => {
        const designCards = document.querySelectorAll('[data-design-card]');

        for (var i = 0; i < designCards.length; i++) {
            designCards[i].style.visibility = 'visible';
        }
    });

    // Contest listings
    scrollOnHover('[data-scrollable="contests"]');
    centerAlignScrollableElement('[data-scrollable="contests"]');

    centerAlignScrollableElement('[data-scrollable="options"]');
    scrollOnHover('[data-scrollable="options"]');

    // Hero carousel
    Carousel.create().start();

    // FAQs
    Accordion.create();

    // Initialise all the product cta
    initialiseProductCTAs();
});

// Initialise design galleries
document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('[data-slide-carousel]');

    Array.from(galleries).forEach(
        gallery =>
            new SlideCarousel({
                element: gallery,
                stepElement: gallery.querySelector('[data-carousel-steps]'),
                stepClickEventMessage: 'Clicked Gallery Control On Designer List',
            })
    );
});

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('Product Page');
});

// Sticky nav
document.addEventListener('DOMContentLoaded', () => {
    const interactiveElement = document.querySelector('[data-get-started-interactive]');

    new StickyBar(
        '[data-sticky-bar]',
        once(() => {
            trackEvent('Viewed Sticky Nav on Product Page');
        })
    );

    createStickyNavWaypoints();

    // Tracking
    const stickyNavCTA = document.querySelectorAll('[data-sticky-nav-item]');

    Array.from(stickyNavCTA).forEach(cta => {
        cta.addEventListener('click', e => {
            if (interactiveElement) {
                e.preventDefault();
            }

            trackEvent('Clicked Sticky Nav Item on Product Page', {
                name: cta.getAttribute('data-sticky-nav-item'),
            });
        });
    });
});

function createStickyNavWaypoints() {
    const offsetTop = 90; // sticky nav bar is 86px height, we need offset top to show the section heading
    const sectionElementAttributes = [
        '[data-trackable-section="featured-contests-carousel"]',
        '[data-trackable-section="how-it-works"]',
        '[data-trackable-section="customer-testimonial"]',
        '[data-trackable-section="pricing"]',
    ];

    sectionElementAttributes.forEach((attr, index) => {
        const element = document.querySelector(attr);

        if (element) {
            new Waypoint({
                element: element,
                handler: () => updateColor(element),
                offset: offsetTop,
            });

            // this is for scrolling up from bottom to top
            if (index < sectionElementAttributes.length - 1) {
                new Waypoint({
                    element: element,
                    handler: () => updateColor(element),
                    offset: () => {
                        return -element.clientHeight;
                    },
                });
            }
        } else {
            // hide the sticky nav tab
            const sectionId = attr.split('"')[1];
            const stickyNavItem = document.querySelector(`[data-page-nav-item="${sectionId}"]`);

            if (stickyNavItem) {
                stickyNavItem.setAttribute('data-hidden', '');
            }
        }
    });
}

function updateColor(element) {
    const color = '#fe5f50';
    const sectionId = element.getAttribute('data-trackable-section');
    const activeElement = document.querySelector(`[data-page-nav-item="${sectionId}"]`);

    if (activeElement) {
        activeElement.setAttribute('data-active', 'true');
        activeElement.style.color = color;
    }

    const navElements = document.querySelectorAll('[data-page-nav-item]');
    navElements.forEach(el => {
        if (el !== activeElement) {
            el.removeAttribute('data-active');
            el.removeAttribute('style');
        }
    });
}

function initialiseProductCTAs() {
    const CTAs = document.querySelectorAll('[data-product-cta]');
    const logoInteractiveElement = document.getElementById('get_started_interactive');
    const trackEventName = 'Clicked CTA on Product page';
    const ctaLocationAttr = 'data-product-cta-location';

    if (window.webOnboarderCategoryPageExperiment === 'onboarder') {
        Array.from(CTAs).forEach(link => {
            link.href = '/web/get-started';
            trackLink(link, trackEventName, {
                cta_location: link.getAttribute(ctaLocationAttr),
            });
        });
        return;
    }

    const triggerCtaToInteractiveEvent = () => {
        let customEvent;
        if (typeof Event === 'function') {
            customEvent = new Event('CtaToInteractive');
        } else {
            // For IE11
            customEvent = document.createEvent('Event');
            customEvent.initEvent('CtaToInteractive', true, true);
        }

        window.dispatchEvent(customEvent);
    };

    Array.from(CTAs).forEach(link => {
        if (logoInteractiveElement) {
            link.addEventListener('click', e => {
                e.preventDefault();

                trackEvent(trackEventName, {
                    cta_location: link.getAttribute(ctaLocationAttr),
                });

                scrollToElement(logoInteractiveElement, 0, 500, triggerCtaToInteractiveEvent);
            });
        } else {
            trackLink(link, trackEventName, {
                cta_location: link.getAttribute(ctaLocationAttr),
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        const offsetTop = element.hasAttribute('data-scrollOffset')
            ? element.getAttribute('data-scrollOffset')
            : 0;
        new ScrollToElement(element, offsetTop).handleClick();
    }
});

// Curated designers carousel tracking
function trackDesignerQuotesListEvents() {
    trackWithLocation('[data-design-card-avatar]', 'avatar');

    trackWithLocation('[data-design-card-username]', 'username');

    trackWithLocation('[data-design-card-reviews]', 'reviews');

    trackWithLocation('[data-design-card-request-button]', 'request-button');
}

function trackWithLocation(selector, location) {
    Array.from(document.querySelectorAll('[data-design-card]')).forEach(designCard => {
        const clickedElement = designCard.querySelector(selector);
        clickedElement.addEventListener('click', () => {
            trackEvent('Designer Carousel on Product Page Clicked', { area: location });
        });
    });
}
